"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.send_log_table_exception_event = exports.send_log_4951_event = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs3/regenerator"));

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));

require("core-js/modules/es.number.constructor.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.regexp.to-string.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.string.replace.js");

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectSpread2"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/asyncToGenerator"));

var _serializeScheme = _interopRequireDefault(require("./serializeScheme"));

var _injectIframe = _interopRequireDefault(require("../utils/injectIframe"));

var _genDynamicFnName = _interopRequireDefault(require("./genDynamicFnName"));

var _ = _interopRequireDefault(require(".."));

/**
 * @file log.ts 日志处理
 * @author wangning25 <wangning25@baidu.com> on 2021/12/05.
 */
// 打点common ext
// const commonExt = (async (): Promise<any> => {
//     return new Promise((resolve, reject) => {
//         const callbackName = genDynamicFnName('getCommonParams');
//         const scheme = serializeScheme({
//             protocol: 'bmls://',
//             moduleName: 'bdmedialive',
//             subModuleName: 'common',
//             actionName: 'getCommonParams',
//             params: {},
//             callbackName
//         });
//         window[callbackName] = res => {
//             let data = res;
//             const ext = {} as any;
//             try {
//                 data = typeof res === 'string' ? JSON.parse(decodeURIComponent(res)) : res;
//                 ext.commonParams = res.data?.commonParams;
//             } catch (error: any) {
//                 ext.commonParams = `Get CommonParams Error:${error.message}`;
//             }
//             return resolve(ext);
//         };
//         setTimeout(() => {
//             resolve({
//                 commonParams: 'Get CommonParams Timeout(800ms)'
//             });
//         }, 800);
//         injectIframe(scheme);
//     });
// })();
// import bmls from '..';
// 打点common ext
// const commonExt = (async (): Promise<any> => {
//     return new Promise((resolve, reject) => {
//         const callbackName = genDynamicFnName('getCommonParams');
//         const scheme = serializeScheme({
//             protocol: 'bmls://',
//             moduleName: 'bdmedialive',
//             subModuleName: 'common',
//             actionName: 'getCommonParams',
//             params: {},
//             callbackName
//         });
//         window[callbackName] = res => {
//             let data = res;
//             const ext = {} as any;
//             try {
//                 data = typeof res === 'string' ? JSON.parse(decodeURIComponent(res)) : res;
//                 ext.commonParams = res.data?.commonParams;
//             } catch (error: any) {
//                 ext.commonParams = `Get CommonParams Error:${error.message}`;
//             }
//             return resolve(ext);
//         };
//         setTimeout(() => {
//             resolve({
//                 commonParams: 'Get CommonParams Timeout(800ms)'
//             });
//         }, 800);
//         injectIframe(scheme);
//     });
// })();
var send_log_4951_event = /*#__PURE__*/function () {
  var _ref = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(monitor) {
    var _window, _window$location, _window2, _window2$navigator;

    var params, scheme;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            // 响应异常时才上报data数据主体
            if (Number(monitor.errno) !== 0) {
              if (monitor.data instanceof Error) {
                monitor.data = monitor.data.toString();
              } else {
                monitor.data = (0, _stringify.default)(monitor.data);
              }
            } else {
              monitor.data = '';
            } // 添加 schemeOrigin（scheme不带参数）


            monitor.schemeOrigin = monitor.scheme.replace(/([^?]*).*/, '$1');
            params = {
              eventType: '1',
              eventId: '4951',
              eventParams: {
                from: 'live',
                value: 'live',
                page: 'webview',
                source: 'webview',
                type: 'webview',

                /**
                 * 提示（防止commonParams字段被覆盖）：
                 * 通过sendLog端能力发送日志时，na端会自动在ext里append一个commonParams参数
                 * commonParams值为 bmls.common.getCommonParams res data.commonParams
                 *
                 */
                ext: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, monitor), {}, {
                  duration: monitor.end - monitor.start,
                  refer: ((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.href) || '',
                  ua: ((_window2 = window) === null || _window2 === void 0 ? void 0 : (_window2$navigator = _window2.navigator) === null || _window2$navigator === void 0 ? void 0 : _window2$navigator.userAgent) || ''
                })
              },
              __skipCheck: true
            };
            scheme = (0, _serializeScheme.default)({
              protocol: 'bmls://',
              moduleName: 'bdmedialive',
              subModuleName: 'common',
              actionName: 'sendLog',
              params: params,
              callbackName: (0, _genDynamicFnName.default)('sendLog')
            });
            (0, _injectIframe.default)(scheme);

          case 5:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function send_log_4951_event(_x) {
    return _ref.apply(this, arguments);
  };
}();

exports.send_log_4951_event = send_log_4951_event;

var send_log_table_exception_event = /*#__PURE__*/function () {
  var _ref2 = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(data) {
    var _window3, _window3$location, _window4, _window4$navigator;

    var params, scheme;
    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // data: {
            //     msg: string;
            //     exceptionType: number;  0普通异常（概率低）、1高频异常（概率高）
            //     table?: string;
            //     detail?: string;
            //     schemeName?: string;
            // }
            params = {
              eventType: '1',
              eventId: '4951',
              eventParams: {
                from: 'live',
                value: 'descriptionTable',
                page: 'webview',
                source: 'webview',
                type: 'exception',
                ext: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
                  refer: ((_window3 = window) === null || _window3 === void 0 ? void 0 : (_window3$location = _window3.location) === null || _window3$location === void 0 ? void 0 : _window3$location.href) || '',
                  ua: ((_window4 = window) === null || _window4 === void 0 ? void 0 : (_window4$navigator = _window4.navigator) === null || _window4$navigator === void 0 ? void 0 : _window4$navigator.userAgent) || '',
                  sdkVersion: _.default.env.sdkVersion || '0.0.0'
                })
              },
              __skipCheck: true
            };
            scheme = (0, _serializeScheme.default)({
              protocol: 'bmls://',
              moduleName: 'bdmedialive',
              subModuleName: 'common',
              actionName: 'sendLog',
              params: params,
              callbackName: (0, _genDynamicFnName.default)('sendLog')
            });
            (0, _injectIframe.default)(scheme);

          case 3:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function send_log_table_exception_event(_x2) {
    return _ref2.apply(this, arguments);
  };
}();

exports.send_log_table_exception_event = send_log_table_exception_event;